import get from 'lodash/get';
import {
    getProductSalePrice,
    getProductSubtotal,
    productIsOnSale,
    getProductListPrice
} from 'services/cartUtils';

import { ImageCircle } from '../imageCircle/imageCircle';
import template from './cartItem.html';
import './cartItem.scss';

export const CartItem = angular
    .module('checkout.components.orderSummary.cartItem', [
        ImageCircle
    ]).component('cartItem', {
        template,
        bindings: {
            item: '<'
        },
        controller: class CartItemCtrl {
            $onInit() {
                this.subtotal = getProductSubtotal(this.item.product, this.item.quantity);
                this.itemIsOnSale = productIsOnSale(this.item.product);
                this.listPrice = getProductListPrice(this.item.product);
                if (this.itemIsOnSale) {
                    this.salePrice = getProductSalePrice(this.item.product.pricing.salePrice);
                }

                this.setCartItemImage(this.item);
            }

            setCartItemImage(cartItem) {
                const imageLink = get(cartItem, 'product.imageMetadata.imageLink');
                if (imageLink) {
                    this.cartItemImage = `${imageLink.uriBase}w_80,h_80,c_fill/${imageLink.imagePath}`;
                }
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/orderSummary/components/cartItem/cartItem.js